import moment from "moment";
export const sortByText = (rowA, rowB, key) => {
  // console.log(rowA)
  const a = rowA[key].toLowerCase().trimStart();
  const b = rowB[key].toLowerCase().trimStart();
  return a.localeCompare(b);
};

export const sortByDate = (rowA, rowB) => {
  if (rowA === "-" || rowA === "Invalid date") {
    return 1;
  }
  if (rowB === "-" || rowB === "Invalid date") {
    return -1;
  }
  const a = moment(rowA, "DD/MM/YYYY");
  const b = moment(rowB, "DD/MM/YYYY");
  return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
};

export const sortByTime = (rowA, rowB) => {
  const a = moment(rowA, "HH:mm");
  const b = moment(rowB, "HH:mm");
  return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
};

export const sortByNumber = (rowA, rowB, key) => {
  let a = parseFloat(rowA[key] ? rowA[key] : 0);
  let b = parseFloat(rowB[key] ? rowB[key] : 0);
  if (rowA[key] === "-") {
    a = 0;
  }
  if (rowB[key] === "-") {
    b = 0;
  }
  return a - b;
};
